module.exports = __webpack_public_path__ + "static/media/notimg3.833a3d84.svg";